import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/posts/[id]/ClientPage.tsx");
